import $ from "jquery";
import "parsleyjs";
export class Forms {
    forms = null;
    parsleyParams = {
        excluded: Parsley.options.excluded + ', input:hidden, select:hidden, textarea:hidden',
        errorClass: 'is-invalid',
        successClass: 'is-valid',
        errorsWrapper: '<div class="invalid-feedback leading-tight"></div>',
        errorTemplate: '<span></span>',
        errorsContainer: function (Field) {
            if (Field.element.type === 'checkbox' || Field.element.type === 'radio') {
                return Field.$element.closest('.input').find('> :visible:last');
            }
        },
        classHandler: function (Field) {
            if (Field.element.type === 'checkbox' || Field.element.type === 'radio') {
                return Field.$element.closest('.input').find('> :visible input');
            }
        }
    }

    constructor($selector = $('form')) {
        if ($selector.length > 0) {
            this.forms = $selector;
        }
    }

    validate() {
        if (this.forms) {
            this.forms.parsley(this.parsleyParams)
        }
    }

    steps() {
        
        var $sections = $('.form-section');
        var next = $('.form-navigation .next');
        var prev = $('.form-navigation .previous');
        var saveBtn = $('.form-navigation .save');
        var reviewBtn = $('.form-navigation .review');
        var step = $('#application-form').data('step');
        prev.data('index', false);
        next.data('index', false);
        saveBtn.data('index', false);


        function navigateTo(index) {
            // Mark the current section with the class 'current'
            $sections
                .removeClass('d-block')
                .addClass('d-none')
                .eq(index)
                .addClass('d-block');
            // Show only the navigation buttons that make sense for the current section:
            prev.toggle(index > 0);
            var atTheEnd = index >= $sections.length - 1;
            next.toggle(!atTheEnd);
            reviewBtn.toggle(atTheEnd);
        }

        function curIndex() {
            // Return the current index by looking at which section has the class 'current'
            return $sections.index($sections.filter('.d-block'));
        }

        // Previous button is easy, just go back
        prev.click(function () {
            var result = null,
                tmp = [];
            var items = location.search.substr(1).split("&");
            for (var index = 0; index < items.length; index++) {
                tmp = items[index].split("=");
                result = decodeURIComponent(tmp[1] - 1);
            };
             console.log(tmp);

             var url = window.location.href
             var regEx = /([?&]step)=([^#&]*)/g;
             var newurl = url.replace(regEx, '$1='+result);
             console.log(newurl)
            window.location.href = newurl;
            $('html, body').animate({ scrollTop: 0 }, 'fast');
            
        });

        reviewBtn.click(function () {
            let form = $(this).closest('form');

            form.parsley(this.parsleyParams).whenValidate({
                group: 'block-' + curIndex()
            });
            document.getElementById("application-form").submit();
            
        });

        // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
        $sections.each(function (index, section) {
            $(section).find('.input [required]').attr('data-parsley-group', 'block-' + index);
        });

        saveBtn.click(function() {
            let index = $(this).data('index');
            navigateTo(index !== false ? index : curIndex());
        });

        // Start at the beginning
        navigateTo(step);
    }

    matrixField () {
        // Admin 
        if ($('#dashboard-level').length) {
            console.log('#dashboard-level...');

            $('#dashboard-level').change(function () {
                var level = $('#dashboard-level').val();

                $('[name="speciality"]').children().each(function () {
                    $(this)[0].hidden = true
    
                    if ($(this).val().match(new RegExp("^" + level + ":")) || $(this).val() == "") {
                        $(this)[0].hidden = false
                    }
                })
            });

            $('#fieldOfStudies').change(function () {
                var level = $('#dashboard-level').val();
                var fieldOfStudies = $('#fieldOfStudies').val();

                $('[name="speciality"]').children().each(function () {
                    $(this)[0].hidden = true
                    
    
                    if ($(this).val().match(new RegExp("^" + level + ":" + fieldOfStudies + ":")) || $(this).val() == "") {
                        $(this)[0].hidden = false
                    }
                })
            });
        }


        // Application
        var forms = $('form');
        var index = 0;

        $('[name="fields[studyLevel]"]').on("change", function () {
            $('.fieldOfStudies').val("")
            $('.fieldOfStudies').trigger("change")
        })

        $('.matrixblock').each(function () {
            bindMatrixBlock($(this))
        })

        function bindMatrixBlock($block) {
            function showFieldOfStudies(value) {
                console.log('showFieldOfStudies...', value)

                var $fieldOfStudies = $block.find('.fieldOfStudies')

                if ($fieldOfStudies.length) {
                    console.log('$fieldOfStudies', $fieldOfStudies);
                
                    $fieldOfStudies.children().each(function () {
                        $(this)[0].hidden = true
                    })
    
                    $fieldOfStudies.find('[value=""]')[0].hidden = false
                    $fieldOfStudies.find('[value="cienciasEEngenharia"]')[0].hidden = false
                    $fieldOfStudies.find('[value="cienciasHumanasESociais"]')[0].hidden = false
    
                    if (value == "BUT") {
                    }
    
                    if (value == "master") {
                        $fieldOfStudies.find('[value="cienciasEEngenharia"]')[0].hidden = false
                        $fieldOfStudies.find('[value="saudeEDesporto"]')[0].hidden = false
                        $fieldOfStudies.find('[value="cienciasHumanasESociais"]')[0].hidden = false
                        $fieldOfStudies.find('[value="artesELetras"]')[0].hidden = false
                    }
                    
                    if (value == "phd") {
                        $fieldOfStudies.find('[value="cienciasEEngenharia"]')[0].hidden = false
                        $fieldOfStudies.find('[value="saudeEDesporto"]')[0].hidden = false
                        $fieldOfStudies.find('[value="cienciasHumanasESociais"]')[0].hidden = false
                        $fieldOfStudies.find('[value="artesELetras"]')[0].hidden = false
                    }
                }
            }
            
            showFieldOfStudies($('[name="fields[studyLevel]"]').val())

            $('[name="fields[studyLevel]"]').on("change", function () {
                showFieldOfStudies($(this).val())
            })

            function showSpecialities($this) {
                var studyLevel = $('.studyLevel').val();
                var area = $this.val();
                var matchStr = studyLevel + ":" + area + ":"
                var $block = $this.closest('.matrixblock')

                $block.find('.id-specifyTheSpeciality2022-field').find('.make-a-selection').remove();

                if (area == "") {
                    $block.find('.id-specifyTheSpeciality2022-field').append('<div class="make-a-selection" style="font-style: italic; font-size: 13px; color: #777">Selecione area de estudos</div>');
                }

                console.log(matchStr)

                var inputs = $block.find('.id-specifyTheSpeciality2022-field').find('input');

                inputs.each(function () {
                    var value = $(this).attr('value');
                    console.log('value>', value)
                    if (value.match(matchStr)) {
                        $(this).parent().show()
                    } else {
                        $(this).parent().hide()
                    }
                })
            }

            $block.find('.fieldOfStudies').each(function () {
                showSpecialities($(this))

                $(this).on("change", function(event) {                    
                    showSpecialities($(this))
                })
            });

            // Update the name attributes
            $block.find('[name],[data-name]').each(function(e) {
                var nameAttr =  this.getAttribute('data-name') || this.getAttribute('name');

                var name = nameAttr.replace('blockId', 'new' + index);

                $(this).attr('name', name );
                
                console.log(this.getAttribute('name'))

                // Old legacy code
                if($(this).hasClass("fieldOfStudies")){
                    $(this).on("change", function(event) {                    
                        var studyLevel =  $('.studyLevel')[0].value;
                        console.log();
                        if(studyLevel == 'BUT' && event.currentTarget.value == 'cienciasEEngenharia'){
                            const but = ['engenhariaQuimicaEngenhariaDeProcessos','engenhariaBiologicaAgroalimentarEIndustriasBiologicas','engenhariaElectricaEComputacaoIndustrial','engenhariaIndustrialEManutencao',"engenhariaMecanicaEGestaoDaProducao", "informaticaRedesETelecomunicacoes", "saudeSegurancaEAmbiente", "medidasFisicas"];
                            //console.log($(this).closest('.matrixblock').find('.specifyTheSpeciality').children());
                            let currentChildren =   $(this).closest('.matrixblock').find('.specifyTheSpeciality').children();
                            for (let index2 = 0; index2 < currentChildren.length; index2++) {
                                if( but.includes(currentChildren[index2].value)){
                                    currentChildren[index2].hidden = false;
                                } else{
                                    currentChildren[index2].hidden = true;
                                }
                            }
                        }
            
                        if(studyLevel == 'BUT' && event.currentTarget.value == 'saudeEDesporto'){
                            const but = ['gestaoDeEmpresasGestaoDeLogisticaETransportes','tecnicasComerciaisEDeMarketing'];
                        
                            let currentChildren =   $(this).closest('.matrixblock').find('.specifyTheSpeciality').children();
                            for (let index2 = 0; index2 < currentChildren.length; index2++) {
                                if(but.includes(currentChildren[index2].value)){
                                    currentChildren[index2].hidden = false;
                                } else{
                                    currentChildren[index2].hidden = true;
                                }
                            }
                        }

                        if(studyLevel != 'BUT' && event.currentTarget.value == 'cienciasEEngenharia'){
                            const but = ['cienciasInformaticasSistemasDeInformacaoMatematicaTelecomunicacoes','biocienciasQuimicaGeocienciasFisicaEngenhariaDoReservatorioCienciasNaturais','geofisicaGeologiaPetroliferaModelacaoDeReservatorios','engenhariaCivilManutencaoLogisticaTransporteHigieneSegurancaEAmbiente','engenhariaElectricaInstrumentosFisicaDeProcessos','analiseDeSegurancaGestaoDeSeguranca','arquitectura','agriculturaAgronegociosCienciaEProcessamentoDeAlimentos'];
                        
                            let currentChildren =   $(this).closest('.matrixblock').find('.specifyTheSpeciality').children();
                            for (let index2 = 0; index2 < currentChildren.length; index2++) {
                                if(but.includes(currentChildren[index2].value)){
                                    currentChildren[index2].hidden = false;
                                } else{
                                    currentChildren[index2].hidden = true;
                                }
                            }
                        }

                        if(studyLevel != 'BUT' && event.currentTarget.value == 'saudeEDesporto'){
                            const but = ['bancaEFinancasInvestimentoBancario','direitoContratoEAquisicoesControloJudicialCienciasPoliticasRelacoesInternacionaisContabilidadeAuditoriaGestaoDeEmpresasRecursosHumanos'];
                        
                            let currentChildren =   $(this).closest('.matrixblock').find('.specifyTheSpeciality').children();
                            for (let index2 = 0; index2 < currentChildren.length; index2++) {
                                if(but.includes(currentChildren[index2].value)){
                                    currentChildren[index2].hidden = false;
                                } else{
                                    currentChildren[index2].hidden = true;
                                }
                            }
                        }

                        if(studyLevel != 'BUT' && event.currentTarget.value == 'cienciasHumanasESociais'){
                            const but = ['sociologiaPsicologiaSocialAntropologiaSocialFilosofia','geografiaEOrdenamentoTerritorialDemografiaSaudeEEstudosDeSustentabilidade'];
                        
                            let currentChildren =   $(this).closest('.matrixblock').find('.specifyTheSpeciality').children();
                            for (let index2 = 0; index2 < currentChildren.length; index2++) {
                                if(but.includes(currentChildren[index2].value)){
                                    currentChildren[index2].hidden = false;
                                } else{
                                    currentChildren[index2].hidden = true;
                                }
                            }
                        }

                        if(studyLevel != 'BUT' && event.currentTarget.value == 'artesELetras'){
                            const but = ['cienciasDaEducacaoEstudosDaComunicacaoEstudosLiterariosEstudosCulturaisEstudoDasArtes','francesLinguaEstrangeiraFle'];
                        
                            let currentChildren =   $(this).closest('.matrixblock').find('.specifyTheSpeciality').children();
                            for (let index2 = 0; index2 < currentChildren.length; index2++) {
                                if(but.includes(currentChildren[index2].value)){
                                    currentChildren[index2].hidden = false;
                                } else{
                                    currentChildren[index2].hidden = true;
                                }
                            }
                        }
                
                    } );
                }
            })
            // $('.datepicker').datepicker({
            //      minViewMode: "months",
            //      format: 'mm/yyyy'
            // });

            var $authorField = $block.find('[name$="[authorId]"]');
            var $authorNameField = $block.find('[name$="[authorName]"]');

            if ($authorField.length) {
                $authorField.val(window.user.id);
                $authorNameField.val(window.user.name);
            }

            index = index + 1;
            
        }

        
        forms.on('click', '.addButton', function () {
            //$(this).hide();

            var matrixBlocks = $(this).closest('.form-group').find('.matrixblock');
            index = (matrixBlocks.length ? matrixBlocks.length : index) + 1;
            var $template = $(this).closest('.form-group').find('#fields-blockTemplate');
            
            var $clone = $template.clone()
                .removeClass('d-none')
                .removeAttr('id')
                .data('index', index)
                .addClass('clone matrixblock bg-light p-4 mb-4')
                .insertBefore($template);

            bindMatrixBlock($clone)
        })
              
        forms.on('click', '.removeButton', function () { // Remove button click handler
            var $row = $(this).parents('.matrixblock');
            var form = $(this).closest('form');
            index = form.find('.matrixblock').length - 1;
            $row.remove();
            return false;
        })
    }

    disabledField(){
        $(document).ready(function() {
            $('.matrixblock.advisory-board').each(function () {
                var $block = $(this);
                var $authorField = $block.find('[name$="[authorId]"]');

                if ($authorField.val() == window.user.id) {
                    // do nothing
                } else {
                    $block.find('select').attr('disabled', true);
                    $block.find('textarea').attr('disabled', true);
                    $block.find('input').attr('readonly', true);
                }

                // Hide the add button
                if ($authorField.val() == window.user.id) {
                    $('#fields-advisoryBoardReview-field').find('.addButton').hide();
                }

            });

        });
    }

    hiddenFields(){
        $('select[name="fields[scholarship]"]').on('change',function(){
             var element = document.getElementById('fields-costSharingExplanation-field');
            if (this.value === "costSharingScholarship") {
                element.classList.remove("d-none");
            }
            else 
            {
                element.classList.add("d-none");
            }
        })
        $('select[name="fields[studyLevel]"]').on('change',function(){
             var element = document.getElementById('fields-supervisor-field');
             var element2 = document.getElementById('fields-emailAddressOfTheSupervisor-field');
             var element3 = document.getElementById('fields-phdInCotutelle-field');
             var element4 = document.getElementById('fields-supervisorInSouthAfrica-field');
             var element5 = document.getElementById('fields-emailAddressOfTheSupervisorInSouthAfrica-field');
             var element6 = document.getElementById('fields-universityOfTheSupervisorInSouthAfrica-field');
             
            if (this.value === "phd") {
                element.classList.remove("d-none");
                element2.classList.remove("d-none");
                element3.classList.remove("d-none");
                element4.classList.remove("d-none");
                element5.classList.remove("d-none");
                element6.classList.remove("d-none");
            }
            else 
            {
                element.classList.add("d-none");
                element2.classList.add("d-none");
                element3.classList.add("d-none");
                element4.classList.add("d-none");
                element5.classList.add("d-none");
                element6.classList.add("d-none");
            }
        })
        $(".create-account").click(function(){
            $('input[id="customCheck1"]').prop("value", 'I agree');
            var agreeTerms = document.getElementById("customCheck1");
            var agreeTermsCTA = document.getElementById("agreeTerms");
            var loginCTA = document.getElementById("loginCTA");
            var hiddenForm = document.getElementById('hiddenForm');
            var registerForm = document.getElementById('registerForm');
            if  (agreeTerms.value === 'I agree'){
                hiddenForm.classList.remove("d-none");
                agreeTermsCTA.classList.add("d-none");
                loginCTA.classList.add("d-none");
                registerForm.classList.remove("col-md-6");
                registerForm.classList.add("col-md-12");
            }   else {
                hiddenForm.classList.add("d-none");
            }
        });
    }  
    
    fileInput() {

        $(document).on('change', 'input[type="file"]', function () {
          
          var input = $(this);
          var str = this.value;
          var strIndexOf = str.replace(/\\/g, '/');
          var filename = strIndexOf.split("/").pop();
          var parent = input.closest('[data-fileinput]');


          parent.addClass(this.value ? 'fileinput-exists' : 'fileinput-new').removeClass(this.value ? 'fileinput-new' : 'fileinput-exists');
          $(`[data-input-filename][name="${this.name}"]`).text(filename);
          $(`[name="${this.name}[]"]`).val('');
        });

        $(document).on('click', '[data-file-dismiss]', function(){
            var parent = $(this).closest('[data-fileinput]');
            parent.addClass('fileinput-new').removeClass('fileinput-exists');
            $(`[data-input-filename][name="${this.name}"]`).text('');
            $(`[name="${this.name}[]"]`).val('');
        })
    }  

    selectLists(){
        let studyLevel = "BUT";
        $('.studyLevel').on('change', function(){ 
            studyLevel = this.value;
        });

        $('.addButton').on('click', function(){ 
            if($(this).closest('.form-group')[0].id == "fields-universityInstitution-field"){
                let studies = $(this).closest('.form-group').find('.fieldOfStudies');
                for (let index = 0; index < studies.length; index++) {
                    if(!studies[index].value){
                        if(studyLevel == 'BUT'){
                            //loop through 
                            for (let index2 = 0; index2 < studies[index].children.length; index2++) {
                                if(studies[index].children[index2].value == "cienciasHumanasESociais" || studies[index].children[index2].value == "artesELetras"){
                                    studies[index].children[index2].hidden = true;
                                }
                                
                            }
                        } else{
                            for (let index2 = 0; index2 < studies[index].children.length; index2++) {
                                studies[index].children[index2].hidden = false;
                            }
                        }
                    }
                }
            }
        });
    }
}